import script from "./ContentFileSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentFileSummary.vue?vue&type=script&setup=true&lang=ts"

import "./ContentFileSummary.vue?vue&type=style&index=0&id=25252e64&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25252e64"]])

export default __exports__